import PartnerSubscriptionsApi from '../api/partnersubscriptions'

export const LOAD_RDSPARTNERS_REQUESTED = 'pools/LOAD_RDSPARTNERS_REQUESTED'
export const LOAD_RDSPARTNERS_COMPLETED = 'pools/LOAD_RDSPARTNERS_COMPLETED'
export const LOAD_RDSPARTNERS_ERROR = 'pools/LOAD_RDSPARTNERS_ERROR'

export const loadRdsPartners = () => {
  return dispatch => {
    dispatch({
      type: LOAD_RDSPARTNERS_REQUESTED
    })
    return PartnerSubscriptionsApi.GetRdsPartners()
      .then(response => {
        return response.json()
      })
      .then(json => dispatch({
        type: LOAD_RDSPARTNERS_COMPLETED,
        data: json.data
      }))
      .catch(error => {
        dispatch({
          type: LOAD_RDSPARTNERS_ERROR,
          error: 'There has been a problem with loading RDS partners : ' + error.message
        })
        console.log('There has been a problem with loading RDS partners: ', error)
      })
  }
}


// WEBPACK FOOTER //
// ./src/actions/rdsPartners.js